import React, { Component } from 'react';
import SearchIcon from '../assets/icons/search.svg';
import SearchBar from '../CommonComponents/SearchBar';
import { RandomizedUserBadgeColors } from '../constants';
import { api } from '../utils';
import CheckBox from '../assets/icons/check_box_unchecked.svg';
import SelectedCheckBox from '../assets/icons/check_box_checked.svg';
import ThemedButton from '../CommonComponents/ThemedButtons';
import crossImg from '../assets/icons/close-smallSize.svg';
import AddQueue from '../assets/icons/add.svg';
import RadioBtnUnchecked from '../assets/icons/radio_button_unchecked.svg';
import RadioBtnchecked from '../assets/icons/radio_button_checked.svg';
import AddIcon from '../assets/icons/add.svg';

type Props = {
  botId: string;
  src?: string;
  closeModal: Function;
  closeModals: Function;
  tenantId: number;
};

type State = {
  searchTerm: string;
  userList: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    agentId: string;
    BotId: string;
  }[];
  selectedUser: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    agentId: string;
    BotId: string;
  }[];
  showUserList: boolean;
  addQueues: boolean;
  queueList: {
    queueId: number;
    queueName: string;
    check: boolean;
  }[];
  selectedQueueList: {
    queueId: number;
    queueName: string;
    check: boolean;
  }[];
  analystRole: boolean;
  adminRole: boolean;
  roleType: string;
  adminAnalystData: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    agentId: string;
    BotId: string;
  }[];
  agentRole: boolean;
};

export default class AddExistingUser extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.selectedUser = this.selectedUser.bind(this);
    this.addQueueList = this.addQueueList.bind(this);
    this.saveData = this.saveData.bind(this);
  }
  setInitialState(): State {
    return {
      searchTerm: '',
      userList: [],
      selectedUser: [],
      showUserList: true,
      addQueues: false,
      selectedQueueList: [],
      queueList: [],
      analystRole: false,
      adminRole: false,
      roleType: 'Agent',
      adminAnalystData: [],
      agentRole: false,
    };
  }
  componentDidMount() {
    let encodedbotId = encodeURIComponent(this.props.botId);
    api(
      `getAgentsList?botId=${encodedbotId}&tenantId=${this.props.tenantId}&tabName=team`
    ).then((response) => {
      let agentData = response.agents.filter(
        (filterData: any) => filterData.RoleName === 'Agent'
      );
      this.setState({
        userList: agentData.map((res: any, index: number) => {
          return {
            userName: res.userName,
            email: res.EmailId,
            queues: res.currentQuest,
            id: index,
            check: false,
            agentId: res.AgentId,
            currentQuest: res.currentQuest,
            RoleName: res.RoleName,
          };
        }),
      });
    });
    api(
      `getExistingUsers?botId=${encodeURIComponent(this.props.botId)}&tenantId=${
        this.props.tenantId
      }&agentId=${sessionStorage.getItem('agentId')}`
    ).then((res) => {
      this.setState({
        adminAnalystData: res.agents.map((res: any, index: number) => {
          return {
            userName: res.userName,
            email: res.EmailId,
            queues: res.currentQuest,
            id: index,
            check: false,
            agentId: res.AgentId,
            currentQuest: res.currentQuest,
            RoleName: res.RoleName,
            BotId: res.BotId,
          };
        }),
      });
    });
  }
  get userList() {
    const searchTerm = this.state.searchTerm.toLowerCase();
    localStorage.setItem('searchTermOfUserList', searchTerm);
    if (this.props.src === 'team-tab') {
      return this.state.adminAnalystData.filter(
        (filterData) => filterData.userName.toLowerCase().indexOf(searchTerm) >= 0
      );
    } else {
      return this.state.userList.filter(
        (filterData) => filterData.userName.toLowerCase().indexOf(searchTerm) >= 0
      );
    }
  }
  selectedUser() {
    if (this.props.src === 'team-tab') {
      var selectedUser = this.state.adminAnalystData.filter((data) => {
        return data.check === true;
      });
    } else {
      var selectedUser = this.state.userList.filter((data) => {
        return data.check === true;
      });
    }

    this.setState({
      selectedUser: selectedUser,
      showUserList: !this.state.showUserList,
    });
  }
  removeAgent(agentId: any) {
    this.setState((prevState) => ({
      selectedUser: prevState.selectedUser.map((obj) =>
        obj.agentId === agentId ? Object.assign(obj, { check: !obj.check }) : obj
      ),
    }));
  }
  removeQueue(queueId: any) {
    this.setState((prevState) => ({
      selectedQueueList: prevState.selectedQueueList.map((obj) =>
        obj.queueId === queueId ? Object.assign(obj, { check: !obj.check }) : obj
      ),
    }));
  }
  get queueDetails() {
    const searchTerm = this.state.searchTerm.toLowerCase();
    return this.state.queueList.filter(
      (filterData) => filterData.queueName.toLowerCase().indexOf(searchTerm) >= 0
    );
  }
  addQueueList() {
    const list = this.state.queueList.filter((data) => data.check === true);
    this.setState({
      selectedQueueList: list,
    });
  }
  saveData() {
    let agentIds: any = [];
    let queueIds: any = [];
    this.state.selectedQueueList.map((val: any) => {
      queueIds.push(val.queueId);
    });
    let agentsData: any = [];
    this.state.selectedUser.map((val: any) => {
      agentIds.push(parseInt(val.agentId));
      agentsData.push({ agentId: val.agentId, botId: val.BotId });
    });
    if (this.props.src === 'team-tab') {
      let dataSet = {
        agentData: agentsData,
        roleName: this.state.roleType,
        // botId: encodeURIComponent(this.props.botId),
        botId: this.props.botId,
      };
      api('editRoleForMultipleUsers', 'POST', dataSet).then((res) => {
        this.props.closeModal(res.msg);
      });
    } else {
      let data = {
        botId: encodeURIComponent(this.props.botId),
        assignedQueueIds: queueIds,
        agentIds: agentIds,
      };
      api('manyToManyMapping', 'POST', data).then((res) => {
        if (res.msg === 'Agents added') {
          this.props.closeModal(res.msg);
        }
      });
    }
  }
  get selectedUserData() {
    return this.state.selectedUser.filter((data: any) => data.check === true);
  }
  get AdminAnalystData() {
    return this.state.adminAnalystData.filter((data: any) => data.check === true);
  }
  render() {
    return (
      <div style={{ width: '450px' }}>
        {this.state.showUserList ? (
          <div>
            <SearchBar
              placeholder='Search users'
              icon={SearchIcon}
              importedImg='yes'
              onSearch={(term: any) => {
                this.setState({
                  searchTerm: term,
                });
              }}
              src='teamtab'
            />
            <div
              className='frst-wrapper'
              style={{
                maxHeight: '320px',
                overflowY: 'auto',
                padding: '20px 0px 20px 0px',
                minHeight: '320px',
              }}>
              {this.userList.length > 0 ? (
                this.userList.map((userData, index) => {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        borderBottom: ' 1px solid #0000001a',
                        alignItems: 'center',
                        padding: '10px 0px 10px 0px',
                      }}>
                      <div
                        key={index}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          if (this.props.src === 'team-tab') {
                            this.setState((prevState) => ({
                              adminAnalystData: prevState.adminAnalystData.map((obj) =>
                                obj.id === userData.id
                                  ? Object.assign(obj, { check: !userData.check })
                                  : obj
                              ),
                              selectedUser: [
                                ...prevState.selectedUser,
                                {
                                  userName: userData.userName,
                                  email: userData.email,
                                  queues: userData.queues,
                                  id: index,
                                  check: !userData.check,
                                  agentId: userData.agentId,
                                  BotId: userData.BotId,
                                },
                              ],
                            }));
                          } else {
                            this.setState((prevState) => ({
                              userList: prevState.userList.map((obj) =>
                                obj.id === userData.id
                                  ? Object.assign(obj, { check: !userData.check })
                                  : obj
                              ),
                              selectedUser: [
                                ...prevState.selectedUser,
                                {
                                  userName: userData.userName,
                                  email: userData.email,
                                  queues: userData.queues,
                                  id: index,
                                  check: !userData.check,
                                  agentId: userData.agentId,
                                  BotId: userData.BotId,
                                },
                              ],
                            }));
                          }
                        }}>
                        <img
                          src={userData.check ? SelectedCheckBox : CheckBox}
                          alt='checkbox'
                        />
                      </div>
                      <div
                        style={{
                          backgroundColor:
                            RandomizedUserBadgeColors[
                              userData.userName[0].toLocaleLowerCase().charCodeAt(0) % 97
                            ],
                        }}
                        className='user-badge'>
                        {userData.userName[0]}
                      </div>
                      <div className='user-details'>
                        <span style={{ textTransform: 'capitalize' }}>
                          {userData.userName}
                        </span>
                        <span className='break-data'>{userData.email}</span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    fontSize: '12px',
                    color: 'rgba(0,0,0,0.6',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}>
                  {localStorage.getItem('searchTermOfUserList') !== '' ? (
                    <>No users found</>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 'max-content',
                      }}>
                      <span>All users on this tenant are already added to the bot.</span>
                      <span>Click ‘Add a new user’ to add new users to the tenant.</span>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              style={{
                marginTop: '15px',
                display: 'flex',
                justifyContent: 'space-between',
              }}>
              <div
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => {
                  this.props.closeModals(true);
                }}>
                <img src={AddIcon} alt='add icon' />
                <span style={{ fontSize: '14px', fontWeight: 600, color: ' #6c7ef2' }}>
                  Add a new user
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ThemedButton
                  title='Next'
                  theme='4'
                  onClick={() => {
                    this.selectedUser();
                  }}
                  disabled={this.AdminAnalystData.length > 0}
                />
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div
              className={`agent-pills ${
                this.selectedUserData.length > 0 ? 'align-team-data' : ''
              } `}>
              {this.selectedUserData &&
                this.selectedUserData.map((list, i) => {
                  if (list.check === true) {
                    return (
                      <div key={i}>
                        <div style={{ fontSize: '14px', textTransform: 'capitalize' }}>
                          {list.userName}
                        </div>
                        <img
                          src={crossImg}
                          alt='close'
                          onClick={() => {
                            this.removeAgent(list.agentId);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    );
                  }
                })}
            </div>
            {this.props.src === 'team-tab' ? (
              <>
                <div style={{ fontSize: '16px' }}>Select role</div>
                <div style={{ display: 'flex', marginTop: '15px' }}>
                  <img
                    src={
                      this.state.roleType === 'Admin'
                        ? RadioBtnchecked
                        : RadioBtnUnchecked
                    }
                    alt='radio-btn'
                    onClick={() => {
                      this.setState({
                        adminRole: !this.state.adminRole,
                        analystRole: false,
                        roleType: 'Admin',
                      });
                    }}
                  />
                  <div style={{ marginLeft: '10px' }}>
                    <span style={{ fontSize: '14px' }}>Admin</span>
                    <div style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '10px' }}>
                      Access only to bot configurations and analytics in Hybrid Chat{' '}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', marginTop: '15px' }}>
                  <img
                    src={
                      this.state.roleType === 'Analyst'
                        ? RadioBtnchecked
                        : RadioBtnUnchecked
                    }
                    alt='radio-btn'
                    onClick={() => {
                      this.setState({
                        analystRole: !this.state.analystRole,
                        adminRole: false,
                        roleType: 'Analyst',
                      });
                    }}
                  />
                  <div style={{ marginLeft: '10px' }}>
                    <span style={{ fontSize: '14px' }}>Analyst</span>
                    <div style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '10px' }}>
                      Access only to Hybrid Chat analytics{' '}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', marginTop: '15px' }}>
                  <img
                    src={
                      this.state.roleType === 'Agent'
                        ? RadioBtnchecked
                        : RadioBtnUnchecked
                    }
                    alt='radio-btn'
                    onClick={() => {
                      this.setState({
                        agentRole: !this.state.agentRole,
                        analystRole: false,
                        roleType: 'Agent',
                      });
                    }}
                  />
                  <div style={{ marginLeft: '10px' }}>
                    <span style={{ fontSize: '14px' }}>Agent</span>
                    <div style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '10px' }}>
                      Access only to chat screens & bot queues{' '}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div style={{ lineHeight: 2 }}>Assigned Queues</div>
                {this.state.selectedQueueList && (
                  <div
                    className={`agent-pills ${
                      this.state.selectedQueueList.length > 0 ? 'align-team-data' : ''
                    } `}>
                    {this.state.selectedQueueList &&
                      this.state.selectedQueueList.map((list, i) => {
                        if (list.check === true) {
                          return (
                            <div key={i}>
                              <div style={{ fontSize: '14px' }}>{list.queueName}</div>
                              <img
                                src={crossImg}
                                alt='close'
                                onClick={() => {
                                  this.removeQueue(list.queueId);
                                }}
                                style={{ cursor: 'pointer' }}
                              />
                            </div>
                          );
                        }
                      })}
                  </div>
                )}
                <div
                  style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                  onClick={() => {
                    this.setState({
                      addQueues: !this.state.addQueues,
                    });
                  }}>
                  <img src={AddQueue} alt='add' style={{ marginLeft: '-5px' }} />
                  <span style={{ color: '#6c7ef2', fontSize: '14px' }}>Add</span>
                </div>
              </>
            )}
            <>
              {this.state.addQueues && (
                <div className='add-team-queues-w team-queue'>
                  <div className='add-team-queues'>
                    <SearchBar
                      placeholder='Search queues'
                      importedImg='yes'
                      icon={SearchIcon}
                      onSearch={(term: any) => {
                        this.setState({
                          searchTerm: term,
                        });
                      }}
                    />
                    <div style={{ overflowY: 'auto', maxHeight: '200px' }}>
                      {this.queueDetails.map((queueData, i) => {
                        return (
                          <div
                            key={i}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '7px',
                            }}>
                            <img
                              src={queueData.check ? SelectedCheckBox : CheckBox}
                              onClick={() => {
                                this.setState((prevState) => ({
                                  queueList: prevState.queueList.map((obj) =>
                                    obj.queueId === queueData.queueId
                                      ? Object.assign(obj, { check: !queueData.check })
                                      : obj
                                  ),
                                }));
                              }}
                              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />

                            <div style={{ marginLeft: '10px' }}>
                              {queueData.queueName}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: '10px 0px 10px 0px',
                      }}>
                      <ThemedButton
                        theme='4'
                        title='Done'
                        onClick={() => {
                          this.addQueueList();
                          this.setState({
                            addQueues: !this.state.addQueues,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ marginRight: '10px' }}>
                <ThemedButton
                  title='Back'
                  theme='3'
                  onClick={() => {
                    this.setState({
                      showUserList: !this.state.showUserList,
                    });
                  }}
                  disabled={this.selectedUserData.length > 0}
                />
              </div>
              <ThemedButton
                title='Done'
                theme='4'
                onClick={() => {
                  this.saveData();
                }}
                disabled={this.selectedUserData.length > 0}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
